/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductListResVo } from './ProductListResVo';
import {
    ProductListResVoFromJSON,
    ProductListResVoFromJSONTyped,
    ProductListResVoToJSON,
    ProductListResVoToJSONTyped,
} from './ProductListResVo';

/**
 * 
 * @export
 * @interface SkuBatchUploadResVo
 */
export interface SkuBatchUploadResVo {
    /**
     * 
     * @type {Array<ProductListResVo>}
     * @memberof SkuBatchUploadResVo
     */
    records?: Array<ProductListResVo>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SkuBatchUploadResVo
     */
    invalidSkuCodes?: Array<string>;
}

/**
 * Check if a given object implements the SkuBatchUploadResVo interface.
 */
export function instanceOfSkuBatchUploadResVo(value: object): value is SkuBatchUploadResVo {
    return true;
}

export function SkuBatchUploadResVoFromJSON(json: any): SkuBatchUploadResVo {
    return SkuBatchUploadResVoFromJSONTyped(json, false);
}

export function SkuBatchUploadResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkuBatchUploadResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(ProductListResVoFromJSON)),
        'invalidSkuCodes': json['invalidSkuCodes'] == null ? undefined : json['invalidSkuCodes'],
    };
}

export function SkuBatchUploadResVoToJSON(json: any): SkuBatchUploadResVo {
    return SkuBatchUploadResVoToJSONTyped(json, false);
}

export function SkuBatchUploadResVoToJSONTyped(value?: SkuBatchUploadResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(ProductListResVoToJSON)),
        'invalidSkuCodes': value['invalidSkuCodes'],
    };
}

